import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ConditionalWrapper, Icon, TextSize } from '@as/cotopaxi';
import { Box, Link, TextAlpha } from '@yonderland/andes-react';
import { getBoxPropsFromAEMPaddings } from '../../util/AEMUtil';
import { aemColorToCotopaxiColor, mapAemColorToAndesColor, mapListItemTextSize, mapTextSizeToVariant, } from './list.utils';
export const ListItemContent = ({ item }) => {
    const textSize = item.displayAsHeading ? TextSize.LARGE : mapListItemTextSize[item.textSize || 'medium'];
    const textVariant = mapTextSizeToVariant[textSize];
    const isEmphasized = item.displayAsHeading || item.textWeight === 'bold';
    const iconColor = aemColorToCotopaxiColor[item.textColor || 'dark'];
    const textColor = mapAemColorToAndesColor[item.textColor || 'dark'];
    const text = item.displayAsHeading || item.textTransform === 'uppercase'
        ? (item.text || '').toUpperCase()
        : item.textTransform === 'lowercase'
            ? (item.text || '').toLowerCase()
            : item.text || '';
    const borderClassName = item.borders ? Object.values(item.borders).filter(Boolean).join(' ') : '';
    const handleObfuscatedClick = (e) => {
        e.preventDefault();
        if (item.openInNewWindow) {
            window.open(item.link, '_blank', 'noopener');
        }
        else {
            window.location.href = item.link;
        }
    };
    return (_jsx("div", { className: borderClassName, children: _jsx(Box, Object.assign({}, getBoxPropsFromAEMPaddings(item.paddings), { children: _jsxs(ConditionalWrapper, { condition: !!item.link, wrapper: children => (_jsx(Link, { variant: "tertiary", href: item.isObfuscated ? undefined : item.link, target: item.openInNewWindow ? '_blank' : undefined, testId: "list-item-link", onClick: item.isObfuscated && item.link ? handleObfuscatedClick : undefined, children: children })), children: [!!item.icon && (_jsxs(_Fragment, { children: [_jsx(Icon, { color: iconColor, inline: true, name: item.icon, size: item.iconSize }), ' '] })), _jsx(TextAlpha, { color: textColor, strong: isEmphasized, variant: textVariant, as: "span", children: text })] }) })) }));
};
